<template>
<div class="company">
    <template>
        <p class="child-title">企业新闻</p>
        <p class="child-sub-title">CORPORATE NEWS</p>
        <ul>
            <router-link :to="{path:'/news-detail',query:{id:item.id}}" v-for="(item,index) in datas.data" tag="li" :key="index">
                <img :src="item.image" alt srcset />
                <div>
                    <p class="name">{{item.name}}</p>
                    <p class="date">{{item.date}}</p>
                    <p class="desc">{{item.summary}}</p>
                </div>
            </router-link>
        </ul>
        <el-pagination :page-size="6" background layout="prev, pager, next" :total="datas.total" @current-change="change"></el-pagination>
    </template>
</div>
</template>

<script>
import {
    article
} from "../../assets/js/api";
export default {
    data() {
        return {
            datas: {},
            page: 1,
        };
    },
    created() {
        this.getData();
    },
    methods: {
        change(e) {
            console.log(e)
            this.page = e;
            this.getData();
        },
        getData() {
            article({
                limit: 6,
                page: this.page,
                where: {
                    type: 1,
                },
            }).then((r) => {
                this.datas = r.data;
            });
        },
    },
};
</script>

<style lang="less" scoped>
li {
    display: flex;

    img {
        width: 3.19rem;
        height: 2.78rem;
        box-sizing: border-box;
    }

    div {
        width: calc(100% - 3.19rem);
        padding: 0.35rem 0.23rem;
        box-sizing: border-box;
        margin-bottom: 0.3rem;
        background: #f3f3f3;
        height: 2.78rem;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0.27rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            margin-bottom: 0.17rem;
        }

        .date {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            margin-bottom: 0.28rem;
        }

        .desc {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            font-size: 0.26rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
        }
    }
}

.el-pagination {
    margin-top: .98rem
}
</style>
